export type DetailPlayerSubNavTab =
  | 'transcript'
  | 'summary' // formerly OpenAI call summary, now Anthropic AI notes
  | 'ask_fathom'
  | 'ai_notes' // formerly Anthropic AI notes, now legacy

export function isSummaryTab(tab: DetailPlayerSubNavTab): boolean {
  return tab === 'summary' || tab === 'ai_notes'
}
